<template>
  <v-dialog
    :content-class="
      'order-dialog' /*backgroundSrc || (item && item.imageUri) ? 'order-dialog' : 'order-dialog item-no-image'*/
    "
    v-model="dialog"
    @keydown.esc="close"
    persistent
  >
    <div v-if="item && orderItem" class="d-container">
      <v-icon @click="close" class="d-close-button">mdi-close-circle</v-icon>
      <div v-if="itemImageOnly">
        <img v-if="itemImageSrc && item.options.length == 0" :src="itemImageSrc" class="d-background" />
      </div>
      <div v-else class="d-body">
        <div v-if="itemImageSrc" class="item-image-panel">
          <v-img :src="itemImageSrc" class="item-image" />
        </div>
        <img v-if="popupBackgroundSrc" :src="popupBackgroundSrc" class="d-background" :style="popupBackgroundStyle" />
        <div class="item-content-panel">
          <div class="panel-body">
            <div v-if="itemDescr" class="item-descr">
              {{ itemDescr }}
            </div>

            <div v-if="showItemPrice">
              <span v-if="itemPrice != itemDiscountedPrice" class="price-crossout price">{{
                itemPrice | currency
              }}</span>
              <span class="price"> {{ itemDiscountedPrice | currency }}</span>
            </div>

            <div v-if="itemDetail" class="item-detail">
              {{ itemDetail }}
            </div>
            <div class="item-options">
              <div v-for="(og, index) in itemOptions" :key="index">
                <v-row align="center" class="option-group-row">
                  <v-col class="d-flex align-center">
                    <div v-if="og.ID >= 800000">
                      {{ $t(og.name) }}
                    </div>
                    <div v-if="og.ID < 800000">
                      <span v-if="$store.state.descrIndex == 0">
                        {{ og.name }}
                      </span>
                      <span v-if="$store.state.descrIndex == 1">
                        {{ og.name1 }}
                      </span>
                      <span v-if="$store.state.descrIndex == 2">
                        {{ og.name2 }}
                      </span>
                    </div>
                  </v-col>

                  <v-col v-if="og.max > 0" cols="3" lg="2" class="option-group-max">
                    {{ $t("item_option_upto") }}:{{ og.max }}
                  </v-col>
                  <v-col v-if="og.min > 0" cols="3" lg="2" class="option-group-min">
                    {{ $t("item_option_require") }}:{{ og.min }}
                  </v-col>
                  <v-col cols="2" lg="1" class="option-group-sel justify-end">
                    <div v-show="og.qty > 0">{{ og.qty }}</div>
                  </v-col>
                </v-row>

                <v-row v-if="og.chgqty > 0 && og.chgway == 0" class="option-group-row-charge-info">
                  <v-col class="text-center">{{ $t("item_option_charge_free", { value: og.chgqty }) }} </v-col>
                </v-row>

                <v-row v-if="og.chgqty > 0 && og.chgway == 1" class="option-group-row-charge-info">
                  <v-col class="text-center">{{ $t("item_option_charge_lowest", { value: og.chgqty }) }} </v-col>
                </v-row>
                <v-row v-if="og.chgqty > 0 && og.chgway == 2" class="option-group-row-charge-info">
                  <v-col class="text-center">{{ $t("item_option_charge_highest", { value: og.chgqty }) }} </v-col>
                </v-row>

                <div class="option-grid">
                  <v-row align="center" class="option-item-row" v-for="opt in og.items" :key="opt.ID">
                    <v-col cols="5">
                      <div class="option-descr">
                        <span v-if="$store.state.descrIndex == 0">
                          {{ opt.descr }}
                        </span>
                        <span v-if="$store.state.descrIndex == 1">
                          {{ opt.descr1 }}
                        </span>
                        <span v-if="$store.state.descrIndex == 2">
                          {{ opt.descr2 }}
                        </span>
                      </div>
                    </v-col>

                    <v-col cols="3" class="text-right">
                      <span v-show="getOptionPriceVisibility(opt)" class="option-price"
                        ><div v-if="orderItem.redeemItem && opt.redeemable && opt.redeemPoints > 0">
                          {{ opt.redeemPoints }} pts
                        </div>
                        <div v-else>{{ getOptionPrice(opt) | currency }}</div></span
                      >
                    </v-col>

                    <v-col v-if="og.opt" cols="4" class="text-right">
                      <div v-if="opt.soldout" class="option-soldout">
                        {{ $t("soldout") }}
                      </div>
                      <div v-else class="option-qty-box">
                        <v-icon @click="updateOptionQty(og, opt, 1)">mdi-plus</v-icon>
                        <span :class="['qty', { 'qty-highlight': opt.qty > 0 }]">{{ opt.qty }}</span>
                        <v-icon @click="updateOptionQty(og, opt, -1)">mdi-minus</v-icon>
                      </div>
                    </v-col>
                    <v-col v-else cols="4" class="text-right option-toggle-col">
                      <v-switch
                        class="v-switch-right"
                        hide-details
                        :ripple="false"
                        color="secondary"
                        v-if="!opt.soldout"
                        v-model="opt.toggle"
                        @change="toggleOption(og, opt)"
                      ></v-switch>
                      <span v-else class="option-soldout">
                        {{ $t("soldout") }}
                      </span>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$store.getters.padSetting.menuMode !== true && !itemOrderDisabled" class="d-bottom">
        <div class="d-bottom-child">
          <div class="qty-box">
            <v-icon
              class="order-qty-button"
              v-show="orderItem.cbRefID == 0"
              :disabled="orderItem.cbRefID > 0 || orderItem.qty <= minQty"
              @click="updateOrderQty(-1)"
            >
              mdi-minus
            </v-icon>
            <div class="qty-value">{{ orderItem.qty }}</div>
            <v-icon
              v-show="orderItem.cbRefID == 0"
              :disabled="orderItem.cbRefID > 0 || orderItem.qty >= maxQty"
              @click="updateOrderQty(1)"
            >
              mdi-plus
            </v-icon>
          </div>
        </div>
        <div class="d-bottom-child">
          <div class="add-box">
            <v-btn color="primary" @click="addToCart">{{ $t("PAD.add_to_cart") }}</v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import mOrder from "@/modules/order";
import mUtils from "@/modules/utils";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      orderItem: undefined,
      item: undefined,
      newOrder: true,
    };
  },

  computed: {
    maxQty() {
      let max = 50;
      let avaQty = this.$store.getters.itemAvailableQty(this.orderItem.item);
      max = Math.min(max, this.oldOrderQty + avaQty);

      return max;
    },

    minQty() {
      return 1;
    },

    showItemPrice() {
      if (this.itemPrice != this.itemDiscountedPrice) return this.itemPrice > 0;
      else return this.itemDiscountedPrice > 0;
    },

    popupBackgroundSrc() {
      let _backgroundSrc = undefined;
      if (this.$store.getters.padPopupSchema?.background?.image) {
        let image = this.$store.getters.padPopupSchema.background.image;
        if (image && (image.fileSize > 0 || image.altUrl)) _backgroundSrc = image.downloadPath;
      }

      return _backgroundSrc;
    },

    popupBackgroundStyle() {
      return this.$store.getters.padTableSchema?.background?.style;
    },  

    itemOrderDisabled() {
      if (this.item)
        return this.item.orderDisabled === true;
      else
        return true;
    },

    itemImageOnly() {
      return this.item?.menuSchema?.imageOnly === true;
    },

    itemImageSrc() {
      let src = undefined;
      let image = this.item?.menuSchema?.image;
      if (image && (image.fileSize > 0 || image.altUrl)) src = image.downloadPath;
      if (!src) src = this.item?.imageUri;

      return src;
    },

    itemBackgroundSrc() {
      let _backgroundSrc = undefined;
      let image = this.item?.menuSchema?.image;
      if (image && (image.fileSize > 0 || image.altUrl)) _backgroundSrc = image.downloadPath;

      return _backgroundSrc;
    },   

    itemDescr() {
      if (!this.item) return "";

      if (this.$store.state.descrIndex == 0 && this.item.descr) return this.item.descr;
      else if (this.$store.state.descrIndex == 1 && this.item.descr1) return this.item.descr1;
      else if (this.$store.state.descrIndex == 2 && this.item.descr2) return this.item.descr2;
      else return "";
    },

    itemDetail() {
      if (!this.item) return "";

      if (this.$store.state.descrIndex == 0 && this.item.detail) return this.item.detail;
      else if (this.$store.state.descrIndex == 1 && this.item.detail1) return this.item.detail1;
      else if (this.$store.state.descrIndex == 2 && this.item.detail2) return this.item.detail2;
      else return "";
    },

    itemOptions() {
      let options = [];
      if (this.orderItem && this.orderItem.options) {
        this.orderItem.options.forEach(x => {
          if (!x.paKey) options.push(x);
          else {
            for (let i = 0; i < this.orderItem.options.length; i++) {
              let og = this.orderItem.options[i];
              let opt = og.ordered.find(y => y.key == x.paKey);
              if (opt) options.push(x);
            }
          }
        });
      }

      return options;
    },

    itemPrice() {
      let price = this.$store.getters.orderItemSub(this.orderItem);
      if (this.bundleItem && this.bundleItem.bItem) {
        let priceDiff = price - this.bundleItem.itemPrice;
        if (
          this.bundleItem.applyDiff == "all" ||
          (this.bundleItem.applyDiff == "higher" && priceDiff > 0) ||
          (this.bundleItem.applyDiff == "lower" && priceDiff < 0)
        )
          price = priceDiff;
      }

      return price;
    },

    itemDiscountedPrice() {
      let discountedPrice = this.$store.getters.orderItemDiscountedSub(this.orderItem);
      if (this.bundleItem && this.bundleItem.bItem) {
        let itemDiscountedPrice = this.bundleItem.itemPrice;
        if (this.orderItem.itemDiscountable && this.orderItem.itemDiscountRate > 0) {
          itemDiscountedPrice = itemDiscountedPrice * (1 - this.orderItem.itemDiscountRate / 100);
        }
        let priceDiff = discountedPrice - itemDiscountedPrice;
        if (
          this.bundleItem.applyDiff == "all" ||
          (this.bundleItem.applyDiff == "higher" && priceDiff > 0) ||
          (this.bundleItem.applyDiff == "lower" && priceDiff < 0)
        )
          discountedPrice = priceDiff;
      }
      return discountedPrice;
    },
  },

  methods: {
    open(item) {
      this.item = item;
      this.orderItem = this.itemToOrderItem(item);
      this.newOrder = true;
      this.dialog = true;

      this.addDefaultOptions();

      console.log(item, this.orderItem);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      if (this.resolve) this.resolve(true);
      this.dialog = false;
    },

    getOptionPriceVisibility(opt) {
      let optionPrice = this.getOptionPrice(opt);
      return /*this.showPrice && */ optionPrice != 0;
    },

    getOptionPrice(opt) {
      let redeemable = this.orderItem.redeemItem && opt.redeemable;
      let optionPrice = redeemable ? opt.price : this.$store.getters.itemOptionPrice(opt);
      if (this.orderItem.combo != null && !mUtils.isEmptyObject(this.orderItem.combo)) {
        let cb = this.orderItem.combo;
        if (cb.optionOntop) {
          let optionDiscountRate = cb.optionDiscountable ? cb.discountRate : 0;
          optionPrice = mUtils.roundNumber(optionPrice * (1 - optionDiscountRate / 100), 2);
        } else optionPrice = 0;
      } else if (
        this.orderItem.itemDiscountable &&
        this.orderItem.optionDiscountable &&
        this.orderItem.itemDiscountRate > 0
      ) {
        optionPrice = optionPrice * (1 - this.orderItem.itemDiscountRate / 100);
      }

      return optionPrice;
    },

    updateOrderQty(qty) {
      this.orderItem.qty = this.orderItem.qty + qty;
      if (this.orderItem.qty < 1) this.orderItem.qty = 1;
    },

    addDefaultOptions(opt) {
      if (opt) {
        if (opt.key) {
          let ogs = this.orderItem.item.options.filter(x => x.paKey == opt.key);
          for (let og of ogs) {
            let count = 0;
            for (let og_item of og.items) {
              if (og_item.chodef && !og_item.soldout) {
                if (og.max == 0 || og.max > count) {
                  this.optionClicked(og, og_item);
                  count++;
                }
              }
            }
          }
        }
      } else {
        for (let og of this.orderItem.item.options) {
          let count = 0;
          if (!og.paKey)
            for (let og_item of og.items) {
              if (og_item.chodef && !og_item.soldout) {
                if (og.max == 0 || og.max > count) {
                  this.optionClicked(og, og_item);
                  count++;
                }
              }
            }
        }
      }
    },

    optionClicked(og, opt) {
      if (!og || !opt || opt.soldout) return;

      if (og.opt) {
        this.updateOptionQty(og, opt, 1);
      } else {
        opt.toggle = !opt.toggle;
        this.toggleOption(og, opt);
      }
    },

    toggleOption(optionGroup, option) {
      // Rollback toggle state if toggle options exceed max options in group
      let valid = true;

      let cg_qty = 0;
      for (let opt of optionGroup.items) {
        if (opt.toggle) cg_qty++;
      }
      if (option.toggle && optionGroup.max > 0) {
        if (cg_qty > optionGroup.max) {
          if (optionGroup.max == 1) {
            for (let opt of optionGroup.items) {
              if (opt.toggle && opt.ID != option.ID) {
                opt.toggle = false;
                opt.qty = 0;
                cg_qty--;

                for (var ii = 0; ii < optionGroup.ordered.length; ii++) {
                  if (optionGroup.ordered[ii].ID == opt.ID) {
                    optionGroup.ordered.splice(ii, 1);
                    this.deleteOrderedOptonsByOrderGroupKey(opt.key);
                    break;
                  }
                }
                break;
              }
            }
          } else {
            valid = false;
          }
        }
      }

      if (valid) {
        optionGroup.qty = cg_qty;

        if (optionGroup.ordered == null) {
          optionGroup.ordered = Array();
        }

        if (option.toggle) {
          let redeemable = this.orderItem.redeemItem && option.redeemable;
          let optionPrice = redeemable ? option.price : this.$store.getters.itemOptionPrice(option);
          let oo = {
            cgID: optionGroup.ID,
            cgKey: optionGroup.key,
            ID: option.ID,
            key: option.key,
            seq: option.seq,
            descr: option.descr,
            optionPrice: optionPrice,
            price: optionPrice,
            time: Date.now(),
            option: option,
          };
          optionGroup.ordered.push(oo);
        } else {
          for (var i = 0; i < optionGroup.ordered.length; i++) {
            if (optionGroup.ordered[i].ID == option.ID) {
              optionGroup.ordered.splice(i, 1);
              this.deleteOrderedOptonsByOrderGroupKey(option.key);
              break;
            }
          }
        }

        option.qty = option.toggle ? 1 : 0;

        mOrder.updateOptionsValue(this.orderItem);
        this.updateOrderDescription();

        if (option.toggle) this.addDefaultOptions(option);
      } else
        setTimeout(() => {
          option.toggle = false;
          option.qty = 0;
        }, 0);
    },

    updateOptionQty(optionGroup, option, qty) {
      if (option.max !== undefined && option.max > 0) {
        let opt_qty = 0;
        for (let opt of optionGroup.items) {
          if (opt.ID == option.ID) {
            opt_qty += opt.qty;
          }
        }
        if (opt_qty + qty > option.max) return;
      }

      // Rollback option qty if selected options exceed max options in group
      let cg_qty = qty;
      for (let opt of optionGroup.items) {
        cg_qty += opt.qty;
      }
      if (cg_qty < 0) cg_qty = 0;

      let valid = true;
      if (optionGroup.max > 0) {
        if (cg_qty > optionGroup.max) {
          cg_qty -= qty;
          valid = false;
        }
      }
      optionGroup.qty = cg_qty;

      if (valid) {
        if (optionGroup.ordered == null) {
          optionGroup.ordered = Array();
        }

        let oldOptQty = option.qty;
        option.qty = option.qty + qty;
        if (option.qty < 0) option.qty = 0;
        else {
          if (qty > 0) {
            let redeemable = this.orderItem.redeemItem && option.redeemable;
            let optionPrice = redeemable ? option.price : this.$store.getters.itemOptionPrice(option);
            let oo = {
              cgID: optionGroup.ID,
              cgKey: optionGroup.key,
              ID: option.ID,
              key: option.key,
              seq: option.seq,
              descr: option.descr,
              optionPrice: optionPrice,
              price: optionPrice,
              time: Date.now(),
              option: option,
            };
            optionGroup.ordered.push(oo);
          } else if (qty < 0) {
            optionGroup.ordered.sort(this.sortOptionByLatestTime);
            for (var i = 0; i < optionGroup.ordered.length; i++) {
              if (optionGroup.ordered[i].ID == option.ID) {
                optionGroup.ordered.splice(i, 1);
                this.deleteOrderedOptonsByOrderGroupKey(option.key);
                break;
              }
            }
          }
        }

        mOrder.updateOptionsValue(this.orderItem);
        this.updateOrderDescription();

        if (oldOptQty == 0 && qty > 0) this.addDefaultOptions(option);
      }
    },

    updateOrderDescription() {
      this.orderItem.ord_descr = this.getOrderText(this.orderItem, 0);
      this.orderItem.ord_descr1 = this.getOrderText(this.orderItem, 1);
      this.orderItem.ord_descr2 = this.getOrderText(this.orderItem, 2);
    },

    deleteOrderedOptonsByOrderGroupKey(paKey) {
      let ogs = this.orderItem.options.filter(x => x.paKey && x.paKey == paKey);
      if (ogs && ogs.length > 0) {
        console.log("deleteOrderedOptonsByOrderGroupKey", ogs);
        ogs.forEach(og => {
          og.qty = 0;
          og.items.forEach(y => {
            y.toggle = false;
            y.qty = 0;
          });

          og.ordered.forEach(y => {
            this.deleteOrderedOptonsByOrderGroupKey(y.key);
          });
          og.ordered = [];
        });
      }
    },

    checkOrder() {
      let invalid_og;
      for (let og of this.itemOptions) {
        if (og.min > 0 && og.qty < og.min) {
          invalid_og = og;
          break;
        }
      }

      if (invalid_og) {
        let ogName;
        if (this.$store.state.languageSelected.descrIndex == 1) ogName = invalid_og.name1;
        else if (this.$store.state.languageSelected.descrIndex == 2) ogName = invalid_og.name2;
        if (ogName == null || ogName == "") ogName = invalid_og.name;

        this.$root.messageDialog.open(
          this.$t("error_min_option_title"),
          "",
          this.$t("error_min_option_msg", {
            opt_min: invalid_og.min,
            opt_group_name: ogName,
          })
        );
      }

      return invalid_og;
    },

    addToCart() {
      let invalid_og = this.checkOrder();
      if (invalid_og == null) {
        if (this.newOrder) {
          //console.log(this.orderItem);
          if (this.orderItem.options.length > 0) mOrder.addOrderItem(this.orderItem);
          else this.$emit("updateOrderQty", { item: this.item, orderQty: this.orderItem.qty });
          this.close();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.order-dialog {
  height: 90vh !important;
  width: 80vw !important;

  .d-container {
    background-color: white;
    display: flex;

    width: 100%;
    height: 100%;

    position: relative;
    overflow: hidden;

    .d-close-button {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 2;

      color: var(--v-primary-base);
      //border: solid 1px var(--v-primaryText-base);
      font-size: 2.4em;
    }

    .d-background {
      position: absolute;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }

    .d-body {
      height: 100%;
      width: 100%;

      display: flex;

      .item-image-panel {
        z-index: 1;
        //min-width: 350px;
        min-width: 50%;
        max-width: 50%;

        .item-image {
          height: 100%;
        }
      }

      .item-content-panel {
        height: 100%;
        width: 100%;
        //width: 50%;
        z-index: 1;
        padding-top: 36px;

        .panel-body {
          overflow: auto !important;
          height: calc(100% - 72px - 150px - 8px);
          padding: 0px 36px;

          .item-descr {
            font-size: 2.4em;
            line-height: normal;
            //color: var(--v-secondary-base);
            //padding-bottom: 8px;
          }
          .item-detail {
            font-size: 1em;
            line-height: normal;
            color: rgb(50, 50, 50);
            //padding-bottom: 8px;
            margin-top: 8px;
          }

          .price {
            margin-top: 8px;

            font-size: 2em;
            //padding-bottom: 8px;
          }

          .price-crossout {
            text-decoration: line-through;
            color: var(--v-accent-base);
          }

          .item-options {
            margin-top: 8px;

            .option-group-row {
              background-color: rgb(230, 230, 230);

              .col {
                min-height: 56px;
              }

              .option-group-sel {
                display: flex;
                justify-content: center;
                min-width: 60px;
                div {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: var(--v-secondary-lighten2);
                  color: var(--v-secondaryText-base);
                  width: 32px;
                  height: 32px;
                  border-radius: 16px;
                }
              }

              .option-group-max {
                text-align: center;
                white-space: nowrap;
              }

              .option-group-min {
                text-align: center;
                white-space: nowrap;
              }
            }

            .option-item-row {
              .option-qty-box {
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .qty {
                  margin: 0px 8px;
                  height: 32px;
                  width: 32px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
                .qty-highlight {
                  background-color: var(--v-secondary-base);
                  color: var(--v-secondaryText-base);
                  border-radius: 16px;
                }
              }

              .option-price {
                font-size: 1em;
                font-weight: bold;
              }

              .option-soldout {
                color: var(--v-warning-base);
              }
            }
          }
        }
      }
    }

    .d-bottom {
      position: absolute;
      z-index: 2;
      bottom: 0px;

      //height: 80px;
      width: 100%;
      //padding: 0px 60px 40px 60px;
      padding-bottom: 40px;

      display: flex;
      justify-content: space-between;

      .d-bottom-child {
        width: 50%;
        display: flex;
        justify-content: center;
      }

      .qty-box {
        display: flex;
        justify-content: space-between;
        margin: 8px 32px;

        .v-icon {
          color: black;
          font-size: 1.8em;
          font-weight: bold;
          height: 1.8em;
          width: 1.8em;

          background-color: lightgrey;
          border-radius: 1.8em;
          border: solid 1px darkgray;
        }

        .qty-value {
          flex-grow: 1;
          text-align: center;
          font-size: 1.5em;
          font-weight: bold;
          line-height: 1.5em;
          background-color: lightgrey;
          border-radius: 1.5em;
          border: solid 1px darkgray;
          margin: 0px 32px;
          padding: 8px 0px;
          width: 180px;
        }
      }

      .add-box {
        //text-align: center;
        //margin-top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;

        .v-btn {
          font-size: 1.2em;
          min-width: 300px;
          padding: 24px;
          border: solid 1px var(--v-primaryText-base);
        }
      }
    }
  }
}

.item-no-image {
  width: calc(80vw - 350px) !important;
}
</style>
